// Event Bus سبک کلاینت - فیچرهای عرضی (آمار، گیمیفیکیشن، ...) اینجا subscribe می‌کنن
import type { Plan, Signal, ResponseKind, SignalId } from './types';

export type DomainEvent =
  | { kind: 'signal.sent'; signal: Signal; recipientCount: number }
  | { kind: 'response.set'; signalId: SignalId; response: ResponseKind }
  | { kind: 'plan.confirmed'; plan: Plan }
  | { kind: 'plan.outcome'; plan: Plan };

type Handler = (e: DomainEvent) => void;

const handlers = new Set<Handler>();

export const eventBus = {
  subscribe(h: Handler): () => void {
    handlers.add(h);
    return () => handlers.delete(h);
  },
  emit(e: DomainEvent): void {
    handlers.forEach((h) => {
      try { h(e); } catch { /* subscriber نباید هسته رو بشکنه */ }
    });
  },
};
